import { render, staticRenderFns } from "./CardProcess.vue?vue&type=template&id=0b058e2e"
import script from "./CardProcess.vue?vue&type=script&lang=js"
export * from "./CardProcess.vue?vue&type=script&lang=js"
import style0 from "./CardProcess.vue?vue&type=style&index=0&id=0b058e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports